/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import {PackageCategoryEntity} from 'types/entities/PackageCategoryEntity'
import OfferEventCategory from './OfferEventCategory'

interface OfferEventCategoriesListProps {
    eventCategories: PackageCategoryEntity[]
    getShortNameFromId: (id: string) => string
    isCategoryNotSelected: (categoryId: string) => boolean | null
    renderCategoryContent: (eventCategory: PackageCategoryEntity, disabled: boolean) => React.ReactNode
}

const OfferEventCategoriesList = (props: OfferEventCategoriesListProps) => {
    const visibleCategories = props.eventCategories.filter(
        (eventCategory) => eventCategory.enable && !eventCategory.deprecated
    )

    if (!visibleCategories.length) {
        return null
    }

    return (
        <ul className={clsx('OfferEventCategoriesList grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-4 items-start')}>
            {visibleCategories.map((eventCategory) => (
                <OfferEventCategory
                    key={eventCategory.id}
                    eventCategory={eventCategory}
                    getShortNameFromId={props.getShortNameFromId}
                    isCategoryNotSelected={props.isCategoryNotSelected}
                    renderCategoryContent={props.renderCategoryContent}
                />
            ))}
        </ul>
    )
}

export default OfferEventCategoriesList
